export default __webpack_public_path__ + "static/4-1eb8dd9c07dfc21708912868685c9013.jpg";